export default "__VITE_PUBLIC_ASSET__270a2354__"